export default __webpack_public_path__ + "static/media/3132 knife block A top.9f7492d8.png";